import { useState, useCallback } from 'react';
import ENDPOINTS from "../enums/endpoints";
import { sendGetRequest } from "../request/api_request";

export const useStateWiseAccountReport = () => {
    const initState = {
        details: [],
        loading: false,
        error: null,
    };

    const [state, setState] = useState(initState);
    const { details, loading, error } = state;

    const getReport = useCallback(async () => {
        setState((prev) => ({ ...prev, loading: true }));
        try {
            const res = await sendGetRequest({ endpoint: ENDPOINTS.GET_STATEWISE_REPORT });
            setState({ details: res.data, loading: false, error: null });
        } catch (err) {
            setState((prev) => ({ ...prev, loading: false, error: err.message }));
        }
    }, []); // `useCallback` memoizes `getBooks` and prevents unnecessary re-creation

    
    return { details, loading, error, getReport };
};
